export default class GlobalSearchRequest {
    public searchTerm: string = 'test';
    public searchProviders: string[] | null = null;
    public resultsLimit: number | null = null;
}